var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-container m--20" },
    [
      _c(
        "b-form-group",
        [
          _c("label", [_vm._v("Name")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { disabled: true },
            model: {
              value: _vm.dataset_data.name,
              callback: function($$v) {
                _vm.$set(_vm.dataset_data, "name", $$v)
              },
              expression: "dataset_data.name"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bc0d837", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bc0d837","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/jDatasetGeneral.vue
// module id = null
// module chunks = 